<template>
  <div
    :class="{ 'icon-play--loading': loading,
              'icon-play--invert': invert,
              'icon-play--immediate': immediate,
              'animate': animate }"
    class="icon-play"
    @click="clickPlay"
  >
    <div
      v-if="hasTitle"
      class="icon-play__title"
    >
      {{ $t('button_5_1') }}
      <br>
      {{ $t('button_5_2') }}
    </div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
    >

      <g
        fill="none"
        fill-rule="evenodd"
      >
        <!-- eslint-disable max-len -->
        <path
          class="icon-play__shape"
          stroke="#FFF"
          stroke-width="5.669"
          d="M30 3c14.911 0 27 12.089 27 27S44.911 57 30 57 3 44.911 3 30 15.089 3 30 3s27 12.089 27 27"
          stroke-dasharray="212.10 212.10"
          stroke-dashoffset="212.10"
        />
        <!-- eslint-enable max-len -->
        <path
          class="icon-play__path"
          fill="#FFF"
          d="M23 18l20 12-20 12z"
          stroke-dasharray="70.65 70.65"
          stroke-dashoffset="70.65"
        />

      </g>

    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconPlay',

  props: {
    hasTitle: {
      type: Boolean,
      default: true
    },

    loading: {
      type: Boolean,
      required: true
    },

    invert: {
      type: Boolean,
      default: false
    },

    immediate: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      animate: false
    };
  },

  watch: {
    loading(loading) {
      if (!loading) {
        this.animate = true;
      }
    }
  },

  methods: {
    clickPlay() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss" src="@/assets/icons/icon-play-view.scss"></style>



// WEBPACK FOOTER //
// icon-play-view.vue